import GetData from '../../../RestAPI/getDataService';
import FD from '../../../RestAPI/fetchData';
import config from '../../../config/App_data';

const fetchVideos = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/videos/all-videos`, data);
};

const fetchSavedQuestion = async (data) => {
  return await FD.callAPI(`${config.backend_api}/frm_question_bank/getFavVideo`, {
    question_id: data.video_id,
    ...data,
  });
};
const saveQuestion = async (data) => {
  return await FD.callAPI(`${config.backend_api}/frm_question_bank/saveFavVideoByUserID`, data);
};
const deleteSaveQuestion = async (data) => {
  return await FD.callAPI(`${config.backend_api}/frm_question_bank/unsaveFavVideoByUserID`, data);
};
const mutateReportVideo = async (data) => {
  return await FD.callAPI(`${config.backend_api}/frm_question_bank/videoReportQuestion`, data);
};
const saveLastViewedVideo = async (data = {}) => {
  return await FD.callAPI(`${config.backend_api}/frm_question_bank/saveLastViewedVideo`, data);
};
module.exports = {
  fetchVideos,
  fetchSavedQuestion,
  saveQuestion,
  deleteSaveQuestion,
  mutateReportVideo,
  saveLastViewedVideo,
};



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Videos/PlayList/ApiService.js